import axios from 'axios';

let publicKey = null;

// Función auxiliar para convertir PEM a ArrayBuffer
function pemToArrayBuffer(pem) {
    const b64Lines = pem.replace(/-----[^-]+-----/g, '').replace(/\s+/g, '');
    const b64Prefix = b64Lines.replace(/-/g, '+').replace(/_/g, '/');

    const str = window.atob(b64Prefix);
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}

// Función auxiliar para convertir ArrayBuffer a Base64
function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

export const EncryptionService = {
    async init() {
        if (publicKey) {
            return;
        }
        try {
            // Forzar producción por solicitud del usuario
            const baseUrl = 'https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev';

            const response = await axios.get(`${baseUrl}/auth/public-key`);

            if (response.data && response.data.publicKey) {
                const pem = response.data.publicKey;
                const binaryKey = pemToArrayBuffer(pem);

                // Importar llave como CryptoKey
                publicKey = await window.crypto.subtle.importKey(
                    "spki",
                    binaryKey,
                    {
                        name: "RSA-OAEP",
                        hash: "SHA-256" // Asegurarnos de usar SHA-256
                    },
                    true,
                    ["encrypt"]
                );

            } else {
                console.error('EncryptionService: Invalid response format', response.data);
            }
        } catch (error) {
            console.error('Error fetching public key:', error);
        }
    },

    async encrypt(plainText) {
        if (!publicKey) {
            console.warn('Public key not initialized. Returning plain text (NOT SECURE).');
            return plainText;
        }
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(plainText);

            const encryptedBuffer = await window.crypto.subtle.encrypt(
                {
                    name: "RSA-OAEP"
                },
                publicKey,
                data
            );

            const encryptedBase64 = arrayBufferToBase64(encryptedBuffer);
            return encryptedBase64;
        } catch (e) {
            console.error('EncryptionService: Exception during encryption', e);
            return null;
        }
    }
};
